module.exports = __webpack_public_path__ + "04_long_gray.36b9b9b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/04_long_gray.png
// module id = 8qU1
// module chunks = 0